import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  title: {
    fontSize: "24px",
    fontWeight: "normal",
    color: "#0C0E29",
    margin: 0,
  },
}));

/**
 * Styled title for use inside a DialogHeader.
 *
 * @param {string} className - Additional class name
 */
const DialogTitle = ({ className = "", children, ...rest }) => {
  const classes = useStyles();

  return (
    <h2 className={`${classes.title} ${className}`} {...rest}>
      {children}
    </h2>
  );
};

export default DialogTitle;
